import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from '~/pages/home';
import HomeSpa from '~/pages/home-spa';
import ListPlayers from 'src/pages/list-players';
import ListTeams from 'src/pages/list-teams';
import PlayerProfile from '~/pages/player-profile';
import SignIn from '~/pages/sign-in';
import SignUp from '~/pages/sign-up';
import SpaLayout from 'src/spa-layout';
import TeamEditPage from '~/pages/edit-team';

import { PrivateRoute } from '~/PrivateRoute';
import { Analytics } from '~/pages/analytics';

function AppRoutes() {
  return (
    <Router>
      <Routes>
        {/* If authenticated, redirect to /spa-layout, else show the Homepage */}
        <Route
          element={
            <PrivateRoute
              authenticated={true}
              navigateTo="/dashboard"
              from="/"
            />
          }
        >
          <Route path="/" element={<Home />} />
        </Route>

        {/* Auth/Register routes*/}
        <Route
          element={
            <PrivateRoute
              authenticated={true}
              navigateTo="/dashboard"
              from="/auth/login"
            />
          }
        >
          <Route path="/auth/login" element={<SignIn />} />
        </Route>
        <Route
          element={
            <PrivateRoute
              authenticated={true}
              navigateTo="/dashboard"
              from="/auth/login"
            />
          }
        >
          <Route path="/auth/register" element={<SignUp />} />
        </Route>

        {/* Logged in routes*/}
        {/*<Route element={<PrivateRoute navigateTo="/auth/login"/>}>*/}
        {/*    <Route path="/spa-layout" element={<SpaLayout/>}/>*/}
        {/*    <Route path="/about" element={<Home/>}/>*/}
        {/*</Route>*/}
        <Route
          path="/"
          element={
            <PrivateRoute navigateTo="/auth/login">
              <SpaLayout />
            </PrivateRoute>
          }
        >
          {/* Nested routes inside SpaLayout */}
          {/*<Route index element={<Home/>}/>*/}
          <Route path="dashboard" element={<HomeSpa />} /> {/* Default route */}
          <Route path="analytics" element={<Analytics />} />
          <Route path="clients" element={<Analytics />} />
          <Route path="tasks" element={<Analytics />} />
          <Route path="settings" element={<Analytics />} />
          <Route path="about" element={<Analytics />} />
          <Route path="feedback" element={<Analytics />} />
          <Route path="/teams" element={<ListTeams />} />
          <Route path="/teams/:id/edit" element={<TeamEditPage />} />
          <Route path="/teams/:id" element={<ListTeams />} />
          <Route path="/players" element={<ListPlayers />} />
          <Route
            path="/players/:name/:id/:affiliation?"
            element={<PlayerProfile />}
          />
          <Route path="/players/:name/:id" element={<PlayerProfile />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppRoutes;
